import React from 'react';
import clsx from 'clsx';
import { Table, Dropdown } from 'semantic-ui-react';

const DropdownCell = ({
  className,
  disabled,
  isLoading,
  onChange,
  options,
  upward,
  value,
}) => (
  <Table.Cell className={clsx('aridhia-dropdown-cell-container', className)} verticalAlign="middle" singleLine>
    <Dropdown
      className="aridhia-dropdown-cell"
      disabled={disabled || isLoading}
      loading={isLoading}
      onChange={disabled || isLoading ? undefined : onChange}
      options={options}
      value={value}
      upward={upward}
    />
  </Table.Cell>
);

export default DropdownCell;
